import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTele5Component } from './simple-icons-tele5.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTele5Component ],
    exports:      [ SimpleIconsTele5Component ],
    bootstrap:    []
})
export class SimpleIconsTele5Module {}
